export enum PalantirProgressBarModeEnum {
  determinate = 'determinate',
  draggable = 'draggable',
  indeterminate = 'indeterminate',
}

export type PalantirProgressBarMode = keyof typeof PalantirProgressBarModeEnum;
